import "./NewsFilter.scss";
import FilterTypeMenu from "@/components/Common/FilterTypeMenu/FilterTypeMenu.vue";

export default {
  name: "NewsFilter",
  props: [
    "value",
    "issues",
    "channels",
    "features",
    "users",
    "isWorkflowFilter",
    "articleTypes"
  ],
  components: { FilterTypeMenu },
  data: () => ({
    currentFilterUserId: "",
    dialog: false,
    priorities: [
      { title: "Hoch", value: "hoch" },
      { title: "Mittel", value: "mittel" },
      { title: "Niedrig", value: "niedrig" }
    ]
  }),
  mounted() {},
  methods: {
    resetFilter() {
      this.$emit("input", {
        issueId: "",
        creatorId: "",
        channels: "",
        featureIds: "",
        deleted: false
      });
      this.$emit("filterChanged");
      this.dialog = false;
    },
    filter() {
      this.$emit("filterChanged");
      this.dialog = false;
    },
    setIssue(issue) {
      if (!issue?._id) {
        this.value.issueId = "";
        return;
      }
      if (issue._id === this.value.issueId) {
        this.value.issueId = "";
        return;
      }
      this.value.issueId = issue._id;
      this.$emit("filterChanged");
    },
    setPriority(priority) {
      if (!priority?.value) {
        this.value.priority = "";
        return;
      }
      if (priority.value === this.value.priority) {
        this.value.priority = "";
        return;
      }
      this.value.priority = priority.value;
      this.$emit("filterChanged");
    },
    setArticleType(articleType) {
      if (!articleType?.value) {
        this.value.articleType = "";
        return;
      }
      if (articleType.value === this.value.articleType) {
        this.value.articleType = "";
        return;
      }
      this.value.articleType = articleType.value;
      this.$emit("filterChanged");
    },
    selectFeature(feature) {
      if (!feature?._id) {
        return;
      }
      if (
        this.value?.featureIds?.split(",")?.findIndex(f => f === feature._id) >
        -1
      ) {
        const featureIdsArray = this.value.featureIds.split(",");
        const index = featureIdsArray.findIndex(f => f === feature._id);
        featureIdsArray.splice(index, 1);
        this.value.featureIds = featureIdsArray.join(",");
      } else {
        if (!this.value?.featureIds?.length) {
          this.value.featureIds = feature._id;
        } else {
          let featureIdsArray = this.value.featureIds.split(",");
          featureIdsArray.push(feature._id);
          this.value.featureIds = featureIdsArray.join(",");
        }
      }

      this.$emit("filterChanged");
    },
    setUserIdsInFilter(id) {
      if (id) {
        const foundUser = this.users.find(user => user.id === id);
        if (foundUser?._id) {
          if (
            this.value.creatorId?.$in?.includes(foundUser._id) ||
            this.value.creatorId?.$in?.includes(foundUser.id)
          ) {
            this.value.creatorId.$in = this.value.creatorId.$in.filter(
              userId => userId !== foundUser._id && userId !== foundUser.id
            );
            if (!this.value.creatorId.$in.length) this.value.creatorId = "";
            this.$emit("filterChanged");
            return;
          } else this.value.creatorId = { $in: [foundUser._id, foundUser.id] };
        } else {
          if (this.value.creatorId?.$in?.includes(id)) {
            this.value.creatorId.$in = this.value.creatorId.$in.filter(
              userId => userId !== id
            );
            if (!this.value.creatorId.$in.length) this.value.creatorId = "";
            this.$emit("filterChanged");
            return;
          } else this.value.creatorId = { $in: [id] };
        }
      } else {
        this.value.creatorId = "";
      }
      this.$emit("filterChanged");
    },
    toggleChannel(channel) {
      const channelIndex = this.value?.channels
        ?.split(",")
        ?.findIndex(c => c === channel);

      if (channelIndex > -1) {
        const channelsArray = this.value.channels.split(",");
        channelsArray.splice(channelIndex, 1);
        this.value.channels = channelsArray.join(",");
      } else {
        if (!this.value?.channels?.length) this.value.channels = channel;
        else this.value.channels += `,${channel}`;
      }

      this.$emit("filterChanged");
    },
    isCheckedChannel(channel) {
      return (
        this.value?.channels?.split(",")?.findIndex(c => c === channel) > -1
      );
    }
  },
  computed: {
    selectedFeatures() {
      return this.value.featureIds.split(",") || [];
    },
    selectedUsers() {
      if (!this.value?.creatorId) return [];
      return this.value.creatorId?.$in || [];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    newsEditor() {
      return this.$store.state.currentUser?.scopes.includes("role:news_editor");
    },
    newsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    }
  }
};
